import { createSelector } from 'reselect';

const selectUser = (state) => state.user;

const selectSession = createSelector(selectUser, (user) => user?.session);

const selectAllUsers = createSelector(selectUser, (user) => user?.users);

const selectUserOtp = createSelector(selectUser, (user) => user?.otpToken);
const selectUserProfile = createSelector(selectUser, (user) => user?.profile);
const selectUserUpdateProfile = createSelector(
	selectUser,
	(user) => user?.updateProfile
);
const selectUserProfileOtp = createSelector(
	selectUser,
	(user) => user?.updateProfileOtp
);
const selectUserProfileOtpConfirm = createSelector(
	selectUser,
	(user) => user?.updateProfileOtpConfirm
);

const selectUserForgetPassword = createSelector(
	selectUser,
	(user) => user?.forgetPassword
);

const getUserSelectedBusiness = createSelector(
	selectUser,
	(user) => user?.selectedBusinessId
);

const selectUserSignupOtpConfirm = createSelector(
	selectUser,
	(user) => user?.signupOtpConfirm
);

const selectAsnaafOtp = createSelector(selectUser, (user) => user?.asnaafOtp);

const selectAsnaafLogin = createSelector(
	selectUser,
	(user) => user?.asnaafLogin
);

const selectFreshRegister = createSelector(
	selectUser,
	(user) => user?.registerFresh
);

const selectCompleteProfile = createSelector(
	selectUser,
	(user) => user?.completeProfile
);

const selectUserWizard = createSelector(selectUser, (user) => user?.wizard);

const userSelectors = {
	selectUser,
	selectSession,
	selectUserOtp,
	selectUserForgetPassword,
	getUserSelectedBusiness,
	selectAllUsers,
	selectUserProfile,
	selectUserUpdateProfile,
	selectUserProfileOtp,
	selectUserProfileOtpConfirm,
	selectUserSignupOtpConfirm,
	selectUserWizard,
	selectAsnaafOtp,
	selectAsnaafLogin,
	selectFreshRegister,
	selectCompleteProfile,
};

export default userSelectors;
